import {
  ShipmentStopType,
  Stop,
} from "@api/graphql/generated/generated-types";
import { getFirstTaskSequence } from "./typeConvertors";

// Structural, so both ForceCompleteModal's stop shape and ForceAttemptModal's
// can be ordered without either owning the rule.
export interface OrderableStop {
  type: ShipmentStopType;
  tasks?: Array<{
    sequenceNumber: number;
  }> | null;
}

// How an order's stops are listed to a dispatcher: route sequence first,
// pick-ups ahead of drop-offs at the same sequence, returns always last.
// Shared so the Force Complete and Force Attempt modals cannot drift apart.
export function compareStopsForDisplay(
  first: OrderableStop,
  second: OrderableStop
): number {
  if (first.type === ShipmentStopType.Return) return 1;
  if (second.type === ShipmentStopType.Return) return -1;
  const taskSequenceDifference: number =
    getFirstTaskSequence(first as Stop) - getFirstTaskSequence(second as Stop);
  if (taskSequenceDifference !== 0) return taskSequenceDifference;
  if (
    first.type === ShipmentStopType.PickUp &&
    second.type !== ShipmentStopType.PickUp
  )
    return -1;
  if (
    first.type !== ShipmentStopType.PickUp &&
    second.type === ShipmentStopType.PickUp
  )
    return 1;
  return 0;
}
